module.exports = __webpack_public_path__ + "static/media/lifeline_step_9_plus.e8d2664b.png";